import React, { useCallback, useEffect, useMemo, useState } from 'react';
import requests from '../api/requests';
import { questionTypesEndpoint } from '../api/endpoints';
import { Collapse, Modal } from 'antd';
import InfoBanner from '../components/InfoBanner';
import emj5 from '../assets/emoji5.svg';
import emj4 from '../assets/emoji4.svg';
import emj3 from '../assets/emoji3.svg';
import emj2 from '../assets/emoji2.svg';
import emj1 from '../assets/emoji1.svg';

export const InfoModalContext = React.createContext();


export const InfoModalContextProvider = props => {

  const [open, setOpen] = useState(false);

  const toggleModal = useCallback((isOpen = false) => {
    setOpen(isOpen)
  }, [])

  const ctx = useMemo(() => {
    return {
      open,
      toggleModal,
    }
  }, [toggleModal, open])

  return (
    <InfoModalContext.Provider value={ctx}>
      <>
        {props.children}
      </>
    </InfoModalContext.Provider>
  )
}
